import React, { useState, useEffect } from 'react';
import * as authClient from '~lib/authClient';
import { getLocalToken } from '~util/token';
// import { useAsync } from 'react-async';
// import { bootstrapAppData } from '../lib/bootstrap';

const AuthContext = React.createContext();

function AuthProvider(props) {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const checkForToken = () => {
    setAuthenticated(!!getLocalToken());
  };

  useEffect(checkForToken, []);

  useEffect(() => {
    if (isAuthenticated) {
      setUser(authClient.getUser());
      // logger.setUser(authClient.getUser());  // TODO: Broken, might be fun later
    } else {
      setUser(null);
      // logger.resetUser();  // TODO: Broken, might be fun later
    }
  }, [isAuthenticated]);

  const login = async form => {
    await authClient.login(form);
    checkForToken();
  };

  const logout = () => {
    authClient.logout();
    checkForToken();
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        user,
      }}
      {...props}
    />
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuth };
